import { Menu } from 'antd'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { useStatsigClient } from '@statsig/react-bindings/src'
import { checkAccess } from '../Auth'
import * as com from '../Common'
import { rememberBorrowerPaidLaunchLanding, trackBorrowerPaidLaunchCtaLanding } from '../Common/borrowerPaidLaunchTracking'
import PlanModal from '../planModal'
import { UR_Owner } from '../State'
import BillingManagement from './billingManagement'
import Borrowers from './Borrowers'
import CallReports from './CallReports/CallReports'
import PublicSiteIntegration from './PublicSiteIntegration/index';
// import CommunicationSetup from './CommunicationSetup/CommunicationSetup'
import CommunicationSetupNew from './CommunicationSetup/CommunicationSetupNew'
import CreditReportSettings from './CreditReportSettings'
import Customization from './Customization/Customization'
import Estimatedclosingfee from './estimatedclosingfee/index'
import './Fixes.css'
import Integration from './Integration'
import Lenders from './Lenders'
import LoanOfficers from './LoanOfficers'
import './Management.css'
import PlanPricing from './planPricing'
import SampleRatesConfig from './SampleRatesConfig/SampleRatesConfig'
import LegacyUserManagement from './userManagement'
import UserManagement from './userManagement/refactor'
import FeatureCustomization from './../setting/feature'
import CreditReport from './../setting/creditReport'
import Profile from './../Profile'
import ApplicationSetting from './ApplicationSetting'
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'

const mapStateToProps = (state) => {
    return {
        subscriptionReducer: state.subscriptionReducer.currentInfo,
    }
}

const ManagementIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.825 15.9H15.9V18.825C15.9 19.3632 16.3368 19.8 16.875 19.8H18.825C19.3632 19.8 19.8 19.3632 19.8 18.825V16.875C19.8 16.3368 19.3632 15.9 18.825 15.9ZM19.8 8.1V5.175C19.8 4.6368 19.3632 4.2 18.825 4.2H16.875C16.3368 4.2 15.9 4.6368 15.9 5.175V8.1H19.8ZM10.05 10.05H13.95V13.95H10.05V10.05ZM7.125 4.2H5.175C4.6368 4.2 4.2 4.6368 4.2 5.175V7.125C4.2 7.6632 4.6368 8.1 5.175 8.1H8.1V5.175C8.1 4.6368 7.6632 4.2 7.125 4.2ZM4.2 16.875V18.825C4.2 19.3632 4.6368 19.8 5.175 19.8H7.125C7.6632 19.8 8.1 19.3632 8.1 18.825V15.9H5.175C4.6368 15.9 4.2 16.3368 4.2 16.875ZM19.8 21.75H15.9C14.8226 21.75 13.95 20.8774 13.95 19.8V15.9H10.05V19.8C10.05 20.8774 9.17738 21.75 8.1 21.75H4.2C3.12262 21.75 2.25 20.8774 2.25 19.8V15.9C2.25 14.8226 3.12262 13.95 4.2 13.95H8.1V10.05H4.2C3.12262 10.05 2.25 9.17737 2.25 8.1V4.2C2.25 3.12263 3.12262 2.25 4.2 2.25H8.1C9.17738 2.25 10.05 3.12263 10.05 4.2V8.1H13.95V4.2C13.95 3.12263 14.8226 2.25 15.9 2.25H19.8C20.8774 2.25 21.75 3.12263 21.75 4.2V8.1C21.75 9.17737 20.8774 10.05 19.8 10.05H15.9V13.95H19.8C20.8774 13.95 21.75 14.8226 21.75 15.9V19.8C21.75 20.8774 20.8774 21.75 19.8 21.75Z"
            fill="#474849"
        />
    </svg>
)

function getItem(label, key, icon, children, type) {
    return { key, icon, children, label, type }
}




const zeitroTestItems = [
    getItem(
        <div
            style={{
                fontSize: 20,
                paddingLeft: 5,
                paddingTop: 10,
                display: 'flex',
                alignItems: 'center',
                color: '#474849',
            }}
        >
            <ManagementIcon />
            <div className="ml-2">Management</div>
        </div>,
        '1',
        null,
        [
            getItem('Application Setting', 'applicationsetting'),
            getItem('Loans', 'loans'),
            getItem('Lenders', 'lender'),
            // getItem("Sample Rates Config", "samplerateconfig"),
            getItem('Call Reports', 'callreports'),
            getItem('Customization', 'customization'),
            getItem('Public Site Integration', 'publicsiteintegration'),
            getItem('Communication Setup', 'communicationsetup'),
            getItem('Team Credit Report', 'creditreportsettings'),
            getItem('User Management', 'usermanagement'),
            getItem('Closing Cost Setting', 'estimatedclosingfee'),
            getItem('Plans And Billing', 'Plans and Billing', null, [
                getItem('Plans And Pricing', 'Pricing'),
                getItem('Billing Management', 'billingManagement'),
            ]),
            
        ],

        'group'
    ),
]



const collectMenuKeys = (items) => {
    const keys = []
    const walk = (nodes) => {
        ;(nodes || []).forEach((node) => {
            if (!node || !node.key) return
            if (node.children && node.children.length) {
                walk(node.children)
            } else if (node.type !== 'group') {
                keys.push(node.key)
            }
        })
    }
    walk(items)
    return keys
}

const getManagementHeader = () => (
    <div
        style={{
            fontSize: 20,
            paddingLeft: 5,
            paddingTop: 10,
            display: 'flex',
            alignItems: 'center',
            color: '#474849',
        }}
    >
        <ManagementIcon />
        <div className="ml-2">Management</div>
    </div>
)

const buildOwnerItems = () => [
    getItem(
        getManagementHeader(),
        '1',
        null,
        [
            getItem('Application Setting', 'applicationsetting'),
            getItem('Loans', 'loans'),
            getItem('Lenders', 'lender'),
            getItem('Call Reports', 'callreports'),
            getItem('Company Profile', 'customization'),
            getItem('Public Site Integration', 'publicsiteintegration'),
            getItem('Communication Setup', 'communicationsetup'),
            getItem('Team Credit Report', 'creditreportsettings'),
            getItem('User Management', 'usermanagement'),
            getItem('Closing Cost Setting', 'estimatedclosingfee'),
            com.getCustomerId() !== 'mobilehomeloans'
                ? getItem('Plans And Billing', 'Plans and Billing', null, [
                      getItem('Plans And Pricing', 'Pricing'),
                      getItem('Billing Management', 'billingManagement'),
                  ])
                : null,
        ],
        'group'
    ),
]

const buildGreenboxOwnerItems = () => [
    getItem(
        getManagementHeader(),
        '1',
        null,
        [
            getItem('Company Profile', 'customization'),
            getItem('User Management', 'usermanagement'),
            getItem('Closing Cost Setting', 'estimatedclosingfee'),
        ],
        'group'
    ),
]

const buildNonOwnerItems = () => [
    getItem(
        getManagementHeader(),
        '1',
        null,
        [
            getItem('Profile', 'profile'),
            getItem('Feature customization', 'feature'),
            getItem('Communication setup', 'communicationsetup'),
            getItem('Credit report', 'creditReport'),
        ],
        'group'
    ),
]

const getManagementMenuItems = () => {
    if (com.getCustomerId() === 'greenbox') {
        return com.getLoId() === 'ed729143-4314-418d-97b4-e4ea21b5584d'
            ? buildOwnerItems()
            : buildGreenboxOwnerItems()
    }
    return checkAccess([UR_Owner]) ? buildOwnerItems() : buildNonOwnerItems()
}

const getDefaultManagementKey = () => {
    const menuKeys = collectMenuKeys(getManagementMenuItems())
    return menuKeys[0] || (checkAccess([UR_Owner]) ? 'applicationsetting' : 'profile')
}

const resolveManagementKey = (key) => {
    const menuKeys = collectMenuKeys(getManagementMenuItems())
    if (key && menuKeys.includes(key)) return key
    return getDefaultManagementKey()
}

const Management = (props) => {
    const defaultMenuKey = getDefaultManagementKey()
    const [selectedKey, setSelectedKey] = useState([defaultMenuKey])
    const [current, setCurrent] = useState(
        defaultMenuKey === 'applicationsetting' ? <ApplicationSetting /> : null
    )
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [managementMenuHidden, setManagementMenuHidden] = useState(false)
    const location = useLocation()
    const history = useHistory()
    const { client: statsigClient } = useStatsigClient()
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        // Capture campaign query before onClick → history.replace strips search.
        rememberBorrowerPaidLaunchLanding(location.search)
        trackBorrowerPaidLaunchCtaLanding(statsigClient, {
            landing_role_hint: checkAccess([UR_Owner]) ? 'owner' : 'non_owner',
        })
        const queryParams = new URLSearchParams(location.search)
        const hasParam = queryParams.has('select')
        const creditTab = queryParams.get('creditTab')
        if (creditTab === 'HardPull' || creditTab === 'SoftPull') {
            sessionStorage.setItem('creditReportTeamTab', creditTab)
        }
        if (hasParam) {
            onClick({
                key: resolveManagementKey(queryParams.get('select')),
            })
        } else {
            onClick({
                key: resolveManagementKey(sessionStorage.getItem('path')),
            })
        }
    }, [location.search, statsigClient])
    const [showUser, setShowUser] = useState(null)
    useEffect(() => {
        if (showUser === null) return
        onClick({ key: checkAccess([UR_Owner]) ? 'usermanagement' : 'profile' })
    }, [showUser])

    const renderPublicSiteIntegration = () => {
        const webToolVersion = sessionStorage.getItem('web_tool')
        return webToolVersion === 'OLD' ? <Integration /> : <PublicSiteIntegration />
    }

    const renderUserManagement = () => {
        const webToolVersion = sessionStorage.getItem('web_tool')
        const Component = webToolVersion === 'OLD' ? LegacyUserManagement : UserManagement
        return (
            <Component
                showUser={showUser}
                toLoans={() => {
                    onClick({ key: 'loans' })
                }}
                toPricing={() => {
                    onClick({ key: 'Pricing' })
                }}
            />
        )
    }

    const onClick = (e) => {
        setSelectedKey(e.key)
        sessionStorage.setItem('path', e.key)
        const queryParams = new URLSearchParams(location.search)
        const hasSelectParam = queryParams.has('select')
        if (location.search && hasSelectParam) {
            history.replace('/app/management')
        }
        const status = com.getStatus(
            com.getLoId(),
            props.subscriptionReducer.loanOfficers
        )
        // if (status === undefined) return
        // if (e.key === 'callreports') {
        //     if (status === 'free') {
        //         setIsModalOpen(true)
        //         return
        //     }
        // }
        switch (e.key) {
            case 'loans':
                track(STATSIG.COMMON.VIEW, PAGE.MGMT_LOANS, { page: PAGE.MGMT_LOANS })
                setCurrent(<Borrowers />)
                break
            case 'lender':
                setCurrent(<Lenders statsigSource="management" toPricing={() => onClick({ key: 'Pricing' })} />)
                break
            case 'loanofficers':
                setCurrent(<LoanOfficers />)
                break
            case 'samplerateconfig':
                setCurrent(<SampleRatesConfig />)
                break
            case 'customization':
                setCurrent(<Customization />)
                break
            case 'publicsiteintegration':
                setCurrent(renderPublicSiteIntegration())
                break
            case 'profile':
                setCurrent(<Profile />)
                break
            case 'communicationsetup':
                setCurrent(<CommunicationSetupNew />)
                break
            case 'feature':
                setCurrent(<FeatureCustomization />)
                break
            case 'creditReport':
                setCurrent(<CreditReport />)
                break
            case 'creditreportsettings':
                setCurrent(<CreditReportSettings />)
                break
            case 'callreports':
                setCurrent(<CallReports setManagementMenuHidden={(hidden) => {
                    setManagementMenuHidden(hidden)
                }} />)
                break
            case 'usermanagement':
                setCurrent(renderUserManagement())
                break
            case 'estimatedclosingfee':
                setCurrent(<Estimatedclosingfee />)
                break
            case 'Pricing':
                setCurrent(
                    <PlanPricing
                        invite={(e) => {
                            if (!e) {
                                // 切换到User Management时，先刷新subscription信息
                                // 这样可以确保获取到最新的用户数量和权限信息
                                onClick({
                                    key: 'usermanagement',
                                })
                            }
                            setShowUser(e)
                        }}
                    />
                )
                break
            case 'billingManagement':
                setCurrent(<BillingManagement />)
                break
            case 'applicationsetting':
                setCurrent(<ApplicationSetting />)
                break
            default:
                break
        }
    }

    return (
        <div className={isMobile ? 'mobileManagementWrap' : 'managementWrap'}>
            <Menu
                onClick={onClick}
                className={isMobile ? 'mobileManagementMenu' : 'managementMenu'}
                selectedKeys={selectedKey}
                mode={isMobile ? 'horizontal' : 'inline'}
                style={{
                    display: managementMenuHidden ? 'none' : '',
                }}
                items={getManagementMenuItems()}
            />
            <div className="management-view">{current}</div>
            <PlanModal
                isModalOpen={isModalOpen}
                closeModal={() => {
                    setIsModalOpen(false)
                }}
            />
        </div>
    )
}

export default connect(mapStateToProps)(Management)
